import { Route, Switch } from "react-router-dom";
import React from "react";
import Home from "../Home";
import AboutUs from "../Pages/AboutUs";
import Contact from "../Pages/Contact";
import Videos from "../Pages/Videos";
import Projects from "../Pages/Projects";
import ThreeDemo from "../Pages/ThreeDemo";

import RobotSimulation from "../Pages/Projects/Works/RobotSimulation";
import GCAssist from "../Pages/Projects/Works/GCAssist";
import HoloworkAssist from "../Pages/Projects/Works/HoloworkAssist";
import ArgoHytosAR from "../Pages/Projects/Works/ArgoHytosAR";
import RyllMesse from "../Pages/Projects/Works/RyllMesse";
import PilkingtonAR from "../Pages/Projects/Works/PilkingtonAR";
import ARConnect from "../Pages/Projects/Works/ARConnect";
import HoloConnect from "../Pages/Projects/Works/HoloConnect";
import SaackeScrubber from "../Pages/Projects/Works/Saacke-Scrubber";
import ConelWeb from "../Pages/Projects/Works/ConelWeb";
import StolpersteinNRW from "../Pages/Projects/Works/StolpersteinNRW";
import BremerhavenGuideIOS from "../Pages/Projects/Works/BremerhavenGuide-IOS";
import QualifyAR from "../Pages/Projects/Works/QualifyAR";
import BremenGo from "../Pages/Projects/Works/BremenGo";
import BarCelona from "../Pages/Projects/Works/BarCelona";
import HoloWork from "../Pages/Projects/Works/HoloWork";

export function Router() {
  return (
    <Switch>
      <Route exact path={"/"} component={Home} />
      <Route path="/home" component={Home} />
      <Route path="/AboutUs" component={AboutUs} />
      <Route path="/Contact" component={Contact} />
      <Route path="/Videos" component={Videos} />
      <Route path="/RobotSimulation" component={RobotSimulation} />{" "}
      <Route path="/GCAssist" component={GCAssist} />{" "}
      <Route path="/HoloworkAssist" component={HoloworkAssist} />{" "}
      <Route path="/ArgoHytosAR" component={ArgoHytosAR} />{" "}
      <Route path="/RyllMesse" component={RyllMesse} />{" "}
      <Route path="/PilkingtonAR" component={PilkingtonAR} />{" "}
      <Route path="/ARConnect" component={ARConnect} />{" "}
      <Route path="/HoloConnect" component={HoloConnect} />{" "}
      <Route path="/Saacke-Scrubber" component={SaackeScrubber} />{" "}
      <Route path="/ConelWeb" component={ConelWeb} />{" "}
      <Route path="/StolpersteinNRW" component={StolpersteinNRW} />{" "}
      <Route path="/BremerhavenGuideIOS" component={BremerhavenGuideIOS} />{" "}
      <Route path="/QualifyAR" component={QualifyAR} />{" "}
      <Route path="/BremenGo" component={BremenGo} />{" "}
      <Route path="/BarCelona" component={BarCelona} />{" "}
      <Route path="/HoloWork" component={HoloWork} />{" "}
      <Route path="/Projects" component={Projects} />
      <Route path="/3D" component={ThreeDemo} />
    </Switch>
  );
}

export default Router;
